import { useState } from 'react';

import styled from 'styled-components';
// import Swiper core and required modules
import SwiperCore, { Keyboard, Navigation, Pagination } from 'swiper';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

import { ORANGE, PRIMARY } from 'constants/colors';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { Dialog } from 'components/shared';

SwiperCore.use([Keyboard, Pagination, Navigation]);

const StyledContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  .gallery-wrapper {
    flex-grow: 1;
    padding-bottom: 20px;
  }

  .gallery {
    height: 100%;
  }

  .swiper-slide {
    position: relative;

    .slide-wrapper {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    color: ${PRIMARY};
  }

  .swiper-button-prev:not(.swiper-button-disabled),
  .swiper-button-next:not(.swiper-button-disabled) {
    filter: drop-shadow(0px 0px 3px white);
  }

  .swiper-pagination-bullet-active {
    background-color: ${ORANGE};
  }
`;

type Props = {
  title: string;
  paragraphs: string[];
  buttonText: string;
  images?: string[];
  onHidden?: () => void;
  onAction: () => void;
};

export default function PromoDialog({
  title,
  paragraphs,
  buttonText,
  images,
  onHidden,
  onAction
}: Props) {
  const [hide, setHide] = useState(false);

  return (
    <Dialog
      title={title}
      headerBgColor={PRIMARY}
      open={!hide}
      onHidden={onHidden}
      PaperProps={{
        sx: { minWidth: 1200, height: '100%' }
      }}
    >
      <StyledContent>
        <div className="static-content">
          {paragraphs.map((paragraph) => (
            <div style={{ padding: 10 }} key={paragraph}>
              <Typography
                variant="h6"
                component="p"
                align="left"
                dangerouslySetInnerHTML={{ __html: paragraph }}
              />
            </div>
          ))}
        </div>
        {!!images && (
          <div className="gallery-wrapper">
            <Swiper navigation keyboard pagination className="gallery">
              {images.map((url) => (
                <SwiperSlide key={url}>
                  <div className="slide-wrapper">
                    <img src={url} alt="" />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
        <div className="static-content">
          <div className="d-flex h-center">
            <Button
              onClick={() => {
                setHide(true);
                onAction();
              }}
              variant="contained"
              size="large"
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </StyledContent>
    </Dialog>
  );
}
